import React from "react";
import PropTypes from "prop-types";
import cuid from "uuid";
import AriaText from "../../elements/aria/AriaText";
import classNames from "classnames";
import Tooltip from "rc-tooltip";
// Baserer seg på rc-tooltip: http://react-component.github.io/tooltip/
class TooltipTrigger extends React.Component {
    constructor(props) {
        super(props);
        this._handleOnVisibleChange = this._handleOnVisibleChange.bind(this);
        this._handleTriggerFocus = this._handleTriggerFocus.bind(this);
        this._handleTriggerBlur = this._handleTriggerBlur.bind(this);
        this.state = {
            tooltipId: this.props.id || `tooltip${cuid()}`,
            visible: false
        };
    }
    _handleOnVisibleChange(isVisible) {
        this.setState({
            visible: isVisible
        });
    }
    _handleTriggerFocus() {
        this.setState({
            visible: true
        });
    }
    _handleTriggerBlur() {
        this.setState({
            visible: false
        });
    }
    render() {
        const content = (React.createElement("span", { role: "tooltip", "aria-hidden": true }, this.props.tooltip));
        const triggerClassName = classNames("gui-tooltipTrigger", {
            "gui-tooltipTrigger--noBorder": this.props.border
        });
        const overlayClassName = classNames({
            "rc-tooltip-wide": this.props.wideContent
        });
        const parentProps = this.props.getParentComponent ? { getTooltipContainer: this.props.getParentComponent } : {};
        const tooltip = (React.createElement(Tooltip, Object.assign({}, parentProps, { placement: this.props.placement, visible: this.state.visible, onVisibleChange: this._handleOnVisibleChange, trigger: this.props.ignoreFocus ? ["hover"] : ["hover", "focus"], destroyTooltipOnHide: false, overlay: content, overlayClassName: overlayClassName }),
            React.createElement("span", null,
                React.createElement("span", { className: triggerClassName, "aria-describedby": this.props.ignoreTabFocus ? null : this.state.tooltipId, tabIndex: this.props.ignoreTabFocus ? null : 0, onFocus: this._handleTriggerFocus, onBlur: this._handleTriggerBlur }, this.props.children),
                React.createElement(AriaText, { id: this.props.ignoreTabFocus ? null : this.state.tooltipId }, this.props.tooltip))));
        return this.props.wrapperClassName ? React.createElement("span", { className: this.props.wrapperClassName }, tooltip) : tooltip;
    }
}
TooltipTrigger.propTypes = {
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    placement: PropTypes.oneOf(["left", "right", "top", "bottom", "topLeft", "topRight", "bottomLeft", "bottomRight"]),
    handleTabFocus: PropTypes.bool,
    border: PropTypes.bool
};
TooltipTrigger.defaultProps = {
    placement: "bottom",
    ignoreTabFocus: false,
    border: true,
    wideContent: false
};
export default TooltipTrigger;
//# sourceMappingURL=Tooltip.js.map